// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Styled} from '@supermove/components';
import {useEffect, useState} from '@supermove/hooks';
import {colors, Typography} from '@supermove/styles';

const ButtonText = Styled.Text`
  ${Typography.Label2}
  color: ${colors.white};
`;

const Button = Styled.ButtonV2`
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 120px;
  border-radius: 4px;
  background-color: ${({
    // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'ThemeP... Remove this comment to see the full error message
    disabled,
  }) => (disabled ? colors.gray.border : colors.blue.interactive)};
`;

const ActivityIndicator = Styled.Loading`
  flex: 1;
`;

type OwnProps = {
  buttonText?: string;
  form: any;
  handleSubmit: (...args: any[]) => any;
};

// @ts-expect-error TS(2456): Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof SubmitButton.defaultProps;

// @ts-expect-error TS(7022): 'SubmitButton' implicitly has type 'any' because i... Remove this comment to see the full error message
const SubmitButton = ({form, handleSubmit, buttonText}: Props) => {
  const [isWaiting, setIsWaiting] = useState(false);
  useEffect(() => {
    // Once the submit has started, if there are no errors we can continue
    // showing the activity indicator while we wait for all the onSuccess
    // actions to run. This logic assumes that the onSuccess will also do
    // something that unmounts this SubmitButton when it is done. If errors
    // are found, then we re-enable this button so that the user can try
    // submitting again.
    const hasErrors = !_.isEmpty(form.errors);
    if (isWaiting && hasErrors) {
      setIsWaiting(false);
    }
  }, [isWaiting, setIsWaiting, form.errors]);

  return (
    <Button
      disabled={isWaiting}
      onPress={() => {
        setIsWaiting(true);
        handleSubmit();
      }}
    >
      {isWaiting ? (
        <ActivityIndicator color={colors.white} size={'small'} />
      ) : (
        <ButtonText>{buttonText}</ButtonText>
      )}
    </Button>
  );
};

SubmitButton.defaultProps = {
  buttonText: 'Save',
};

export default SubmitButton;
